import React from 'react';
import Header from './Header';
import SideMenu from './SideMenu';
import Footer from './Footer';
import '../styles/Layout.css';

interface AppLayoutProps {
  children: React.ReactNode;
  onBack?: () => void;
  backLabel?: string;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, onBack, backLabel }) => {
  return (
    <div className="app-layout">
      <Header onBack={onBack} backLabel={backLabel} />
      <div className="app-body">
        <SideMenu />
        <div className="app-content-wrapper">
          <main className="app-content">{children}</main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
